import React, { useState } from 'react';
import { api } from './api/api';
import HolidayMode from './HolidayMode';

const Settings = () => {
    const [gproToken,  setGproToken]  = useState('');
    const [gpMessage,  setGpMessage]  = useState(null);
    const [gpError,    setGpError]    = useState(null);
    const [gpLoading,  setGpLoading]  = useState(false);

    const [currentPwd, setCurrentPwd] = useState('');
    const [newPwd,     setNewPwd]     = useState('');
    const [confirmPwd, setConfirmPwd] = useState('');
    const [pwMessage,  setPwMessage]  = useState(null);
    const [pwError,    setPwError]    = useState(null);
    const [pwLoading,  setPwLoading]  = useState(false);

    const handleSaveGpro = async () => {
        setGpMessage(null);
        setGpError(null);
        setGpLoading(true);
        try {
            await api.post('/settings/gprotoken', { gprotoken: gproToken });
            setGpMessage('GPRO token saved successfully.');
        } catch (err) {
            setGpError('Failed to save token. Please try again.');
        } finally {
            setGpLoading(false);
        }
    };

    const handleChangePassword = async () => {
        setPwMessage(null);
        setPwError(null);
        if (!currentPwd || !newPwd || !confirmPwd) {
            setPwError('All fields are required.');
            return;
        }
        if (newPwd !== confirmPwd) {
            setPwError('New password and confirmation do not match.');
            return;
        }
        setPwLoading(true);
        try {
            await api.patch('/user/change-password', {
                currentPassword:      currentPwd,
                newPassword:          newPwd,
                confirmationPassword: confirmPwd,
            });
            setPwMessage('Password changed successfully.');
            setCurrentPwd('');
            setNewPwd('');
            setConfirmPwd('');
        } catch (err) {
            const status = err.response?.status;
            if (status === 400) {
                setPwError('Current password is incorrect or passwords do not match.');
            } else {
                setPwError('Failed to change password. Please try again.');
            }
        } finally {
            setPwLoading(false);
        }
    };

    return (
        <>
            <div className="fb-page-header">
                <div className="fb-page-title">Settings</div>
                <div className="fb-page-sub">Manage your account configuration</div>
            </div>

            <div className="fb-card" style={{ maxWidth: 560, marginBottom: 24 }}>
                <div className="fb-card-header">
                    <span className="fb-card-title">GPRO Integration</span>
                </div>
                <div className="fb-card-body">
                    <p style={{ fontSize: 13, color: 'var(--c-text-muted)', marginBottom: 16, lineHeight: 1.6 }}>
                        Enter your GPRO API token to sync race data automatically.
                        You can get it from{' '}
                        <a
                            href="https://app.gpro.net/apiaccess"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: 'var(--c-accent)', fontWeight: 600 }}
                        >
                            app.gpro.net/apiaccess
                        </a>
                        .
                    </p>

                    <div className="fb-field">
                        <label className="fb-label">GPRO Token</label>
                        <div className="fb-row" style={{ alignItems: 'stretch' }}>
                            <input
                                type="text"
                                className="fb-input"
                                value={gproToken}
                                onChange={(e) => setGproToken(e.target.value)}
                                placeholder="Paste your token here…"
                                style={{ flex: 1 }}
                            />
                            <button
                                className="fb-btn fb-btn-primary"
                                onClick={handleSaveGpro}
                                disabled={gpLoading || !gproToken.trim()}
                            >
                                {gpLoading ? 'Saving…' : 'Save'}
                            </button>
                        </div>
                    </div>

                    {gpMessage && <div className="fb-alert fb-alert-success">{gpMessage}</div>}
                    {gpError   && <div className="fb-alert fb-alert-error">{gpError}</div>}
                </div>
            </div>

            <HolidayMode />

            <div className="fb-card" style={{ maxWidth: 560 }}>
                <div className="fb-card-header">
                    <span className="fb-card-title">Change Password</span>
                </div>
                <div className="fb-card-body">
                    <div className="fb-field">
                        <label className="fb-label">Current Password</label>
                        <input
                            type="password"
                            className="fb-input"
                            value={currentPwd}
                            onChange={e => setCurrentPwd(e.target.value)}
                            placeholder="••••••••"
                            autoComplete="current-password"
                        />
                    </div>
                    <div className="fb-field">
                        <label className="fb-label">New Password</label>
                        <input
                            type="password"
                            className="fb-input"
                            value={newPwd}
                            onChange={e => setNewPwd(e.target.value)}
                            placeholder="••••••••"
                            autoComplete="new-password"
                        />
                    </div>
                    <div className="fb-field">
                        <label className="fb-label">Confirm New Password</label>
                        <input
                            type="password"
                            className="fb-input"
                            value={confirmPwd}
                            onChange={e => setConfirmPwd(e.target.value)}
                            placeholder="••••••••"
                            autoComplete="new-password"
                        />
                    </div>

                    <button
                        className="fb-btn fb-btn-primary"
                        onClick={handleChangePassword}
                        disabled={pwLoading}
                        style={{ marginTop: 4 }}
                    >
                        {pwLoading ? 'Saving…' : 'Change Password'}
                    </button>

                    {pwMessage && <div className="fb-alert fb-alert-success" style={{ marginTop: 12 }}>{pwMessage}</div>}
                    {pwError   && <div className="fb-alert fb-alert-error"   style={{ marginTop: 12 }}>{pwError}</div>}
                </div>
            </div>
        </>
    );
};

export default Settings;
